export { fr } from "./fr"
export const evalNs = "eval.evalModal"
export const sessionNs = "eval.sessionModal"

// TODO: Add others namespaces
